import { render, staticRenderFns } from "./PricingRuleLabelMappingFilesGroup.vue?vue&type=template&id=53cc1848&scoped=true&"
import script from "./PricingRuleLabelMappingFilesGroup.vue?vue&type=script&lang=js&"
export * from "./PricingRuleLabelMappingFilesGroup.vue?vue&type=script&lang=js&"
import style0 from "./PricingRuleLabelMappingFilesGroup.vue?vue&type=style&index=0&id=53cc1848&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53cc1848",
  null
  
)

export default component.exports